import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../RoutingAuth/auth.service';
import { AppInjector } from '../../Services/AppInjector';

@Component({
	selector: 'LogInErrorPopUpComponent',
	templateUrl: 'LogInErrorPopUpComponent.html',
	
})
export class LogInErrorPopUpComponent {

	constructor(
		
		private activeModal: NgbActiveModal
	) {
		this.authService = AppInjector.get(AuthService);
		LogInErrorPopUpComponent

	}
	authService: AuthService = null;

	login() {
		if (this.authService) {
			this.authService.login();
		}
	}


	cancel() {
		this.activeModal.close();
	}
}
